import { InjectionToken } from '@angular/core';

export const COMMON_POPUP_ON_LOAD_DATA = new InjectionToken<Promise<any>>('CommonPopupOnLoadData');
